export const SET_BONUS = 'SET_BONUS';
export const PENDING_BONUS = 'PENDING_BONUS';
export const REMOVE_BONUS = 'REMOVE_BONUS';
export const FETCHED_BONUS = 'FETCHED_BONUS';
export const RESET_BONUS_STATE = 'RESET_BONUS_STATE';
